module.exports = __webpack_public_path__ + "img/selected7-min.6097fca0.png";